<template>
  <g>
    <path
      d="M12 21.0002C13.1046 21.0002 14 20.1048 14 19.0002C14 17.8957 13.1046 17.0002 12 17.0002C10.8954 17.0002 10 17.8957 10 19.0002C10 20.1048 10.8954 21.0002 12 21.0002Z"
    />
    <path
      d="M12 3.00024C10.9 3.00024 10 3.90024 10 5.00024V13.0002C10 14.1002 10.9 15.0002 12 15.0002C13.1 15.0002 14 14.1002 14 13.0002V5.00024C14 3.90024 13.1 3.00024 12 3.00024Z"
    />
  </g>
</template>
